'use strict';
'use es6';

// This function is used so that we can stub the window object in tests

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getWindow = exports.getWindow = function getWindow() {
  return window;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/navigation/getWindow.js
// module id = 475
// module chunks = 3 4 5